<template>
  <el-breadcrumb :separator-icon="ArrowRight" style="margin-bottom: 24px;">
    <template v-for="(item, index) in breadcrumbList" :key="index">
      <el-breadcrumb-item :to="{ path: item.path }" v-if="item.path">{{item.label}}</el-breadcrumb-item>
      <el-breadcrumb-item v-else>{{item.label}}</el-breadcrumb-item>
    </template>
  </el-breadcrumb>
</template>

<script setup>
import {ref, watch} from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { useRoute } from 'vue-router'
import {onMounted} from "vue";
const route = useRoute()

const breadcrumbList = ref([])
const breadcrumbMap = {
  // home: [
  //   { label: 'RutaAzul', path: '/' },
  //   { label: '首页管理' },
  // ],
  enterprise: [
    { label: 'RutaAzul', path: '/' },
    { label: '客户管理' },
    { label: '客户列表' },
  ],
  order: [
    { label: 'RutaAzul', path: '/' },
    { label: '客户管理' },
    { label: '订单管理' },
  ],
  preorder: [
    { label: 'RutaAzul', path: '/' },
    { label: '客户管理' },
    { label: '预下单列表' },
  ],
  lead: [
    { label: 'RutaAzul', path: '/' },
    { label: '线索管理' },
    { label: '线索表' },
  ],
  leadWarning: [
    { label: 'RutaAzul', path: '/' },
    { label: '线索管理' },
    { label: '预警配置' },
  ],
  user: [
    { label: 'RutaAzul', path: '/' },
    { label: '客户管理' },
    { label: '用户列表' },
  ],
  tags: [
    { label: 'RutaAzul', path: '/' },
    { label: '标签管理' }
  ],
  ports: [
    { label: 'RutaAzul', path: '/' },
    { label: '物流字典' },
    { label: '全球港口' },
  ],
  hscode: [
    { label: 'RutaAzul', path: '/' },
    { label: '物流字典' },
    { label: 'HS CODE' },
  ],
  containerSize: [
    { label: 'RutaAzul', path: '/' },
    { label: '物流字典' },
    { label: '集装箱尺寸' },
  ],
  stat: [
    { label: 'RutaAzul', path: '/' },
    { label: '数据统计' },
  ],
}
const init = () => {
  breadcrumbList.value = breadcrumbMap[route.name || 'stat']
}
onMounted(() => {
  init()
})
watch(() => route.name, () => {
  init()
})

</script>

<style scoped lang="less">
  @import "index.less";
</style>
